import getTime from "./getTime";

const checkTicketAccess = (access: string) => {
  const now = getTime();
  const isTodaySEAADE =
    now >= getTime("24 Nov 2020") && now < getTime("26 Nov 2020");
  const isTodayIADR =
    now >= getTime("26 Nov 2020") && now < getTime("28 Nov 2020");
  const isTodayAfterBothEvents = now >= getTime("28 Nov 2020");

  if (isTodayAfterBothEvents) {
    return true;
  }

  if (access === "NONE") {
    return false;
  }

  if (access === "SEAADE" && !isTodaySEAADE) {
    return false;
  }

  if (access === "IADR" && !isTodayIADR) {
    return false;
  }

  return true;
};

export default checkTicketAccess;
